import script from "./AnnouncementSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnouncementSection.vue?vue&type=script&setup=true&lang=ts"

import "./AnnouncementSection.vue?vue&type=style&index=0&id=7490260a&lang=css"

const __exports__ = script;

export default __exports__